<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title primary-title> แก้ไขรูปภาพ </v-card-title>
      <v-card-text class="d-flex justify-center">
        <img
          v-if="allowimg && tempurl !== null"
          :src="tempurl"
          @error="allowimg = !allowimg"
          width="180"
        />
        <div v-else>
          <img
            src="https://developers.google.com/maps/documentation/maps-static/images/error-image-generic.png?hl=es-419"
            width="150px"
          />
          <br />
          <p class="font-italic mb-1">* Content Expire</p>
        </div>
      </v-card-text>
      <v-card-text class="d-flex justify-center">
        <input
          ref="image"
          type="file"
          accept="image/*"
          @change="Image()"
          class="d-none"
        />
        <v-btn color="primary" outlined @click="$refs.image.click()"
          >เปลี่ยนรูป</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="(show = false), (tempurl = message.url)"
          >ปิด</v-btn
        >
        <v-btn color="primary" outlined @click="ChangeImage">ตกลง</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["visible", "message"],
  data() {
    return {
      allowimg: true,
      original: null,
      tempurl: null,
    };
  },
  mounted() {
    this.tempurl = this.message.url;
  },
  watch: {
    message: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue && newValue) {
          if (oldValue.url !== newValue.url) {
            this.tempurl = newValue.url;
          }
        }
      },
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    ChangeImage() {
      this.message.url = this.tempurl;
      this.show = false;
    },
    Image() {
      for (const key in this.$refs.image.files) {
        if (Object.hasOwnProperty.call(this.$refs.image.files, key)) {
          const element = this.$refs.image.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}/question/`
            );
            formData.append("fileName", `${vm.$route.params.surveyID}-`);
            this.$store.commit("ToggleLoading");
            vm.$store
              .dispatch("UploadFormData", formData)
              .then((req) => {
                vm.tempurl = req.data;
                this.$store.commit("ToggleLoading");
              })
              .catch(() => {
                this.$store.commit("ToggleLoading");
              });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
              showCancelButton: false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            }).then(() => {
              this.$refs.image.type = "text";
              this.$refs.image.type = "file";
            });
          }
        }
      }
      this.$refs.image.type = "text";
      this.$refs.image.type = "file";
    },
  },
};
</script>
